import { render, staticRenderFns } from "./buyPlan.vue?vue&type=template&id=1f960c7d&"
import script from "./buyPlan.vue?vue&type=script&lang=js&"
export * from "./buyPlan.vue?vue&type=script&lang=js&"
import style0 from "./buyPlan.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports